import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'color'
})
export class ColorPipe implements PipeTransform {

  transform(index: number): any {
    switch (index) {
      case 0: return "#FF7F00"
      case 1: return "#E31A1C"
      case 2: return "#FDBF6F"
      case 3: return "#FB9A99"
      case 4: return "#00D1BD"
      case 5: return "#00A8BA"
      case 6: return "#1F78B4"
      case 7: return "#A6CEE3"
      default: return "#abc"
    }
  }

}
